import WRAP from "WRAP-JS";
import { configLightningNowcastDh, configLightningNowcastLayer } from "./config/ConfigLightningNowcast";
import { nearValidTime } from "../helper/MapUtil";
import MissingDataObserver from "../helper/MissingDataObserver";
import { COMMUNICATE_ERROR_MESSAGE_JMA_NOWCAS_THNDR, COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_LATER } from "../../../constants/ErrorMessage";

class LightningNowcast {

  static NAME = 'Nowcast';

  dh;
  layer;

  ready = false;
  dhAutoUpdate = true;
  visible = false;
  dispatcher;
  validTime = '---';

  coverage;
  //自動更新フラグ
  autoRefresh = true;
  errorMessageInfo;

  constructor(timeController) {
    this.timeController = timeController;
    this.coverage = true;
    this.layer = new WRAP.Geo.Layer(LightningNowcast.NAME);
    this.layer.setVisible(false);
    this.layer.disableInteraction(true);
  }

  setDispatcher(dispatcher) {
    this.dispatcher = dispatcher;
    this.missingDataObserver = new MissingDataObserver(this.dispatcher, MISSING_THRESHOLD, this);
  }

  async initialize() {
    await this.initData();
    this.initLayer();
    this.initTimeController();
    this.ready = true;
  }

  initData() {
    return new Promise(resolve => {
      this.dh = new WRAP.Data(configLightningNowcastDh);

      this.dh.validate((displayTime, data, content) => {
        return this._validateTime(data, displayTime, content);
      });

      this.missingDataObserver.monitoring(LightningNowcast.NAME, this.dh, this.layer);

      this.dh.updated('validtime', ref => {
        this._selectValidTime(ref);
        if (this.updateTimeFunc) {
          this.updateTimeFunc()
        }
        resolve(ref);
      });
      this.dh.updated('timelist', () => {
        if (this.errorMessageInfo) {
          this.dispatcher({type: 'CLEAR_ERROR', payload: this.errorMessageInfo});
          this.errorMessageInfo = null;
        }
      }, () => {
        this.errorMessageInfo = this.dispatcher({type: 'SHOW_ERROR', payload: {
          message: COMMUNICATE_ERROR_MESSAGE_JMA_NOWCAS_THNDR,
          additionalMessage: COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_LATER
        }});
      });
    })
  }

  initLayer() {
    this.layer.configure(this.dh, configLightningNowcastLayer);
  }

  initTimeController() {
    this.timeController.addLayer(this.layer);
    this.timeController.setDisplayTime(this.validTime);
  }

  async drawLayer(visible) {
    this.visible = visible;
    if (!this.ready) {
      await this.initialize();
    }
    this.setVisible(this.visible);
  }

  getLayer() {
    return this.layer;
  }

  setVisible(visible) {
    this.visible = visible;
    if (!this.ready) return;

    if (visible) {
      this.layer.show();
    } else {
      this.layer.hide();
    }

    const enabled = visible && this.autoRefresh;
    if (this.dhAutoUpdate !== enabled) {
      this.dh.setAutoUpdate('validtime', enabled);
      this.dhAutoUpdate = enabled;
    }

    this.dispatcher({type: 'SET_CONTENTS_TIME', payload: this.getTimeInformation()});

  }

  getTimeInformation() {
    return {
      id: LightningNowcast.NAME,
      label: 'LightningNowcast',
      baseTime: this.validTime
    }
  }

  // getLegend() {
  //   return {
  //     id: LightningNowcast.NAME,
  //     label: '雷Nowcast',
  //     component: LegendLightningNowcast,
  //     contents: this
  //   };
  // }

  applyElapsed(elapsed) {
    this.elapsed = elapsed;

    if (!this.ready) return;

    this._selectValidTime(this.dh.retained.validtime);
  }

  applyPlanETD(etd) {
    this.etd = etd;

    if (!this.ready) return;

    this._selectValidTime(this.dh.retained.validtime);
  }

  getCoverage() {
    return this.coverage;
  }

  setCoverage(coverage) {
    if (this.coverage === coverage) {
      return;
    }
    this.coverage = coverage;

    const style = coverage ? 'default' : 'clear_coverage';
    this.layer.setStyle(style);
  }

  setAutoRefresh(autoFlg) {
    if (autoFlg === this.autoRefresh) {
      return;
    }

    this.autoRefresh = autoFlg;

    if (!this.ready) {
      return;
    }
    //コンテンツの自動更新を切り替え
    this.dh.setAutoUpdate('validtime', this.autoRefresh);
    this.dhAutoUpdate = this.autoRefresh;
  }

  setUpdateTimeFunc(func) {
    this.updateTimeFunc = func;
  }

  _selectValidTime(ref) {
    let timeList = ref;
    if (!timeList) return;
    timeList = timeList.validtime;

    let targetTime;
    if (!this.etd) {
      //プラン未選択時
      if (!this.autoRefresh) {
        //タイムコントローラ操作時にレーダーを追加した場合、タイムコントローラの選択時制
        targetTime = this.timeController.getCurrentTime();
      } else {
        targetTime = Date.now();
      }
    } else {
      //プラン選択時
      targetTime = this.etd.getTime() + this.elapsed * 1000;
    }

    const vt = nearValidTime(timeList, targetTime);

    const validTime = this.validTime;

    if (vt && validTime !== vt) {
      this.validTime = vt;
      this._updateDataset();
      this.dispatcher({type: 'SET_CONTENTS_TIME', payload: this.getTimeInformation()});
    }
  }

  /**
   * タイムコントロールモード時のvalid選択
   */
  _validateTime(data, displayTime, content) {
    const vt = nearValidTime(data.retained.validtime.validtime, displayTime);
    if (vt) {
      this.validTime = content.validtime = vt;
      this.dispatcher({type: 'UPDATE_VALID_TIME', payload: this.getTimeInformation()});
      return true;
    }
    return false
  }

  _updateDataset() {
    if (this.validTime !== '---') {
      this.layer.set({
        validtime: this.validTime
      });
    }
  }
}

const MISSING_THRESHOLD = {
  [LightningNowcast.NAME]: 0
};

export default LightningNowcast;